/**
 * Article rédigé le 2026-09-06 à partir de sources web ouvertes et vérifiées automatiquement
 * (6 URL testées, révisé après vérification). Daté au moment des faits : 2025-11-21.
 * À relire avant/après mise en ligne. Format : voir src/blog/README.md
 */
export default {
  "slug": "french-tech-night-2025-besancon-bfc20",
  "title": "French Tech Night 2025 à Besançon : 20 startups en vitrine et la promotion BFC20 dévoilée",
  "excerpt": "Le 19 novembre, la Maison de l'économie a accueilli la 3e French Tech Night : vingt start-up régionales attendues en showroom, plusieurs briques d'IA, et l'annonce des 21 lauréats du programme BFC20.",
  "seoTitle": "French Tech Night 2025 : la promotion BFC20",
  "seoDescription": "Retour sur la 3e French Tech Night du 19 novembre à la Maison de l'économie : vingt start-up régionales en showroom et les 21 lauréats du programme BFC20.",
  "category": "startups",
  "tags": [
    "French Tech BFC",
    "BFC20",
    "Startups",
    "CCI Saône-Doubs",
    "Intelligence artificielle"
  ],
  "author": "jimmy",
  "publishedAt": "2025-11-21",
  "updatedAt": "2025-12-13",
  "featured": false,
  "cover": {
    "image": "/img/blog/besancon-la-cci-et-le-lycee-jules-haag.jpg",
    "credit": "Photo : Besançon, la CCI et le lycée Jules Haag — Wikipedro, CC BY-SA 4.0, via Wikimedia Commons",
    "alt": "Vue en plongée sur le bâtiment de verre incurvé de la Chambre de commerce et d'industrie (Maison de l'économie) à Besançon, entouré des toits de la ville"
  },
  "content": [
    {
      "type": "lead",
      "text": "Mercredi 19 novembre, la Maison de l'économie de Besançon a accueilli la troisième édition de la French Tech Night[^1][^3]. Vingt start-up régionales devaient y tenir un stand en showroom, selon le programme diffusé par les organisateurs[^2], avant l'annonce de la promotion 2025 du programme French Tech BFC20[^3]. Une soirée qui tient lieu, chaque automne, de photographie annuelle de l'écosystème technologique régional."
    },
    {
      "type": "keyfacts",
      "title": "En bref",
      "facts": [
        {
          "label": "Quoi",
          "value": "3e French Tech Night : showroom éphémère de 20 start-up et remise des trophées French Tech BFC20 2025"
        },
        {
          "label": "Quand",
          "value": "Mercredi 19 novembre 2025, à partir de 17 h 30"
        },
        {
          "label": "Où",
          "value": "Maison de l'économie, CCI Saône-Doubs, 46 avenue Villarceau, Besançon"
        },
        {
          "label": "Qui",
          "value": "Organisée par La French Tech Bourgogne-Franche-Comté, avec des partenaires régionaux dont le pôle PMT"
        },
        {
          "label": "Pour qui",
          "value": "Dirigeants, investisseurs, acteurs institutionnels et partenaires de l'écosystème — près de 300 participants attendus"
        }
      ]
    },
    {
      "type": "h2",
      "text": "Une soirée construite en trois temps"
    },
    {
      "type": "p",
      "text": "L'événement s'est tenu à la Maison de l'économie, siège de la [CCI Saône-Doubs](/blog/open-business-cci-jerome-colombain-ia-entreprises-2024), au 46 avenue Villarceau[^5], à partir de 17 h 30[^2]. La French Tech Bourgogne-Franche-Comté, qui pilote l'opération, la présente comme un « showroom éphémère » destiné à rendre visibles, en une soirée, les entreprises qui façonnent le tissu technologique régional[^2]. Le programme diffusé en amont annonçait trois temps[^2] :"
    },
    {
      "type": "ul",
      "items": [
        "**17 h 30 – 19 h 45** : « showroom géant », où les visiteurs étaient invités à découvrir et à tester les produits et services des vingt start-up exposantes, sous la bannière « Je choisis La French Tech »[^2] ;",
        "**19 h 45 – 21 h 30** : cocktail dînatoire et remise des trophées du French Tech BFC20 2025[^2] ;",
        "**À partir de 21 h 30** : networking et rencontres entre entrepreneurs[^2]."
      ]
    },
    {
      "type": "p",
      "text": "Deux semaines avant la date, les organisateurs indiquaient que les vingt stands affichaient complet et attendaient près de 300 participants — dirigeants, investisseurs et acteurs institutionnels[^2]. La page de l'événement évoque, pour sa part, « plus de 350 décideurs » réunis chaque année[^1]. Parmi les soutiens, le pôle de compétitivité PMT annonçait sa présence en amont de la soirée[^5]."
    },
    {
      "type": "h2",
      "text": "Vingt stands, dont une poignée où l'IA est au cœur du produit"
    },
    {
      "type": "p",
      "text": "Les exposants annoncés couvraient l'industrie, la santé, l'environnement, la culture et le numérique[^2]. Une partie d'entre eux met l'IA au cœur du produit, plutôt qu'en argument commercial. Quatre cas se détachent :"
    },
    {
      "type": "ul",
      "items": [
        "**Dicte.ai** propose un assistant de réunion souverain qui enregistre, transcrit, identifie les interlocuteurs, puis génère comptes rendus et plans d'action, avec hébergement en France, chiffrement et une option sur site (DicteBox)[^2] ;",
        "**Davi** développe des agents conversationnels incarnés, combinant IA et *affective computing* pour, selon son descriptif, « humaniser la relation client » et automatiser les échanges 24 h/24[^2] ;",
        "**Priminov** applique l'IA à la traduction en temps réel[^2], en cherchant à saisir le sens des échanges « plutôt que de simples mots »[^3] ;",
        "**Wasoria** équipe les centres de tri de portiques[^2] et de caméras intelligentes[^3] capables de détecter en temps réel les objets dangereux — batteries, bonbonnes — pour prévenir les incendies."
      ]
    },
    {
      "type": "p",
      "text": "D'autres exposants relèvent de l'algorithmique appliquée plus que de l'IA au sens strict : **Percevoir**, qui valorise une recherche issue du CEA, ou **Vibiscus**, dont les modules acoustiques sont pilotés par algorithmes[^2]. Au programme figuraient aussi **Smartesting** — que la French Tech BFC présente comme « une expertise bisontine au rayonnement international » — avec ses outils de test logiciel assistés par modèles (Yest®, Gravity), et **Trinaps**, avec sa ConnectBox, une mallette capable de déployer en quelques minutes un accès Internet multi-réseaux (satellite, 4G/5G, Wi-Fi) pour les événements ou les sites isolés[^2]."
    },
    {
      "type": "h2",
      "text": "BFC20 : vingt et une start-up dans la promotion 2025"
    },
    {
      "type": "p",
      "text": "Le second temps fort de la soirée était l'annonce de la troisième promotion du French Tech BFC20, dont les sélectionnés devaient être dévoilés ce soir-là[^4]. Contrairement à ce que suggère son nom, le programme retient 21 entreprises, sélectionnées pour des solutions situées « au cœur des principaux enjeux de souveraineté industrielle et technologique »[^3]. Sept départements sont représentés — Côte-d'Or, Doubs, Saône-et-Loire, Haute-Saône, Jura, Nièvre et Territoire de Belfort — et les secteurs cités vont de la greentech à la défense, en passant par la healthtech, la cybersécurité, la robotique et le *big data*[^3]."
    },
    {
      "type": "p",
      "text": "Plusieurs lauréats croisent Besançon ou l'IA, parfois les deux. **Smartesting** et **[Percipio Robotics](/blog/micronora-2024-microns-or-jumeau-numerique)**, cette dernière issue de la recherche française (FEMTO-ST, ISIR) et spécialiste de l'assemblage de très haute précision, figurent dans la liste[^3]. **Livdeo**, éditeur de Dicte.ai, y entre également, de même que **Wasoria**, **Priminov**, **AUM Biosync** — qui modélise les rythmes biologiques des travailleurs en horaires décalés avec une « IA explicable et souveraine » — et **Quarks Safety**, qui automatise la conformité chimique et environnementale[^3]."
    },
    {
      "type": "h2",
      "text": "Ce que le label ouvre concrètement"
    },
    {
      "type": "p",
      "text": "Le BFC20 n'est pas un prix honorifique : c'est un programme d'accompagnement, ouvert aux start-up implantées en Bourgogne-Franche-Comté qui remplissent au moins un critère d'innovation — financement innovation régional ou Bpifrance, statut de Jeune Entreprise Innovante, passage par un incubateur ou accélérateur régional, ou financement par un fonds d'investissement français ou européen[^4]. En contrepartie, les lauréates bénéficient de[^4] :"
    },
    {
      "type": "ol",
      "items": [
        "une visibilité régionale et nationale accrue ;",
        "une mise en relation privilégiée avec les acheteurs des administrations publiques ;",
        "un accès au programme BOOSTER 200 pour le développement international ;",
        "un accompagnement du réseau des Correspondants French Tech et l'accès à une veille des opportunités."
      ]
    },
    {
      "type": "callout",
      "tone": "info",
      "title": "Pourquoi ça compte pour Besançon",
      "text": "Une soirée ne fait pas une politique industrielle, mais elle sert de test de densité. Que vingt stands se remplissent en amont, et qu'une partie des lauréats régionaux soit adossée à des laboratoires et des savoir-faire bisontins — microtechniques, test logiciel, robotique de précision — dit quelque chose de la profondeur du bassin local."
    },
    {
      "type": "h2",
      "text": "Une vitrine, pas un bilan"
    },
    {
      "type": "p",
      "text": "La French Tech Night reste ce qu'elle annonce : un showroom, avec ses limites. Les descriptifs diffusés par les organisateurs sont ceux des entreprises elles-mêmes, et une remise de trophées ne préjuge ni des levées de fonds à venir, ni de la capacité de ces sociétés à passer à l'échelle. Reste que l'exercice donne, une fois par an, un inventaire lisible de ce qui se construit entre Besançon, Dijon et Belfort — et la confirmation que l'IA y figure moins comme un sujet à part que comme un ingrédient parmi d'autres dans des produits industriels, logiciels ou environnementaux."
    },
    {
      "type": "h2",
      "text": "Mise à jour — décembre 2025 : le coup de cœur du public revient à un Bisontin"
    },
    {
      "type": "p",
      "text": "Trois semaines après la French Tech Night, la même équipe régionale clôturait un autre de ses programmes. Le 12 décembre 2025, au Village by CA de Dijon, la promotion **French Tech Tremplin Prépa 2025** présentait ses projets. À l'issue des pitchs, le vote de la salle a désigné son coup de cœur : **[Mehdi Mougin](/blog/mehdi-mougin-signon-french-tech-tremplin-besancon) pour SignOn**, une solution bisontine de traduction automatique de la langue des signes française.[^6]"
    },
    {
      "type": "p",
      "text": "Sept mois plus tard, la société qu'il a créée dans la foulée figurera parmi les 102 lauréats nationaux du programme French Tech Tremplin Incubation."
    }
  ],
  "references": [
    {
      "id": 1,
      "title": "La French Tech Night 2025",
      "publisher": "La French Tech Bourgogne-Franche-Comté",
      "url": "https://lafrenchtechbfc.fr/nos-evenements/la-french-tech-night-2025/",
      "type": "official",
      "date": ""
    },
    {
      "id": 2,
      "title": "French Tech Night 2025 : découvrez les startups exposantes !",
      "publisher": "La French Tech Bourgogne-Franche-Comté",
      "url": "https://lafrenchtechbfc.fr/actualites/ecosysteme/french-tech-night-2025-decouvrez-les-startups-exposantes/",
      "type": "official",
      "date": "2025-11-04"
    },
    {
      "id": 3,
      "title": "Découvrez la troisième promotion du French Tech BFC20 !",
      "publisher": "La French Tech Bourgogne-Franche-Comté",
      "url": "https://lafrenchtechbfc.fr/actualites/programmes-french-tech/decouvrez-la-troisieme-promotion-du-french-tech-bfc20/",
      "type": "official",
      "date": "2025-11-21"
    },
    {
      "id": 4,
      "title": "French Tech BFC20 — programme d'accompagnement",
      "publisher": "La French Tech Bourgogne-Franche-Comté",
      "url": "https://lafrenchtechbfc.fr/nos-programmes-daccompagnement/french-tech-bfc20/",
      "type": "official",
      "date": ""
    },
    {
      "id": 5,
      "title": "PMT Propulseur est partenaire de la French Tech Night 2025 !",
      "publisher": "PMT — Pôle des Microtechniques",
      "url": "https://www.pmt-innovation.com/agenda/pmt-propulseur-est-partenaire-de-la-french-tech-night-2025/",
      "type": "official",
      "date": ""
    },
    {
      "id": 6,
      "title": "Clap de fin pour la French Tech Tremplin Prépa 2025 : une promotion inspirante célébrée au Village by CA Dijon",
      "publisher": "La French Tech Bourgogne-Franche-Comté",
      "url": "https://lafrenchtechbfc.fr/actualites/programmes/clap-de-fin-pour-la-french-tech-tremplin-prepa-2025-une-promotion-inspirante-celebree-au-village-by-ca-dijon/",
      "date": "2025-12-12",
      "type": "official"
    }
  ]
};
